import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/Paginated';
import { StediPayer } from 'models/StediPayer';
import { clientBasePath } from 'services/api/groupPayerNetworkStatuses';
import http from 'services/http';

export const stediPayerQueryKeys = {
  base: ['stediPayers'],
  index: (params: Record<string, any>) => ['stediPayers', params],
};

// A clientId searches as an Olio admin for that client, so `assignable` and `assignableTo` are answered
// against its facilities rather than the admin's own.
export async function indexStediPayers(
  {
    clientId,
    ...params
  }: {
    clientId?: string;
    search?: string;
    sortBy?: string;
    page?: number;
    pageSize?: number;
    assignable?: boolean;
    assignableTo?: string;
  },
  signal?: GenericAbortSignal
) {
  return http
    .get<Paginated<StediPayer>>(`${clientBasePath(clientId)}/stedi_payers`, { params, signal })
    .then((response) => response.data);
}
